import { EDITTING_DOCUMENTS, EDITTING_DATA } from './constants'

export const edittingDocumentsChanged = (edittingDocuments) => {
  return {
    type: EDITTING_DOCUMENTS,
    edittingDocuments
  }
}

export const edittingDataChanged = (edittingData) => {
  return {
    type: EDITTING_DATA,
    edittingData
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Data/actions.js